import React from 'react'
import './AnimatedBackground.scss'

const AnimatedBackground: React.FC = () => {
  return (
    <div className="animated-background">
      <div className="particles">
        {Array.from({ length: 50 }).map((_, i) => (
          <div
            key={i}
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 20}s`,
              animationDuration: `${15 + Math.random() * 25}s`,
            }}
          />
        ))}
      </div>
      <div className="mesh-gradient" />
    </div>
  )
}

export default AnimatedBackground 